import * as React from 'react';
import {connect} from 'react-redux';

import {openReplyModal} from '../email-reply-actions';

import {EmailPreviewModal} from './email-preview-modal';

type ReplyType = 'all' | 'single';
type DispatchProps = {
    openReplyModal: (replyToEmailId: string, isReplyingAll: boolean) => void;
};

type Props = DispatchProps;

// @ts-expect-error
function mapDispatchToProps(dispatch): DispatchProps {
    return {
        openReplyModal: (replyToEmailId: string, isReplyingAll: boolean) => {
            dispatch(openReplyModal({replyToEmailId, isReplyingAll}));
        },
    };
}

export const TimelineEmailOpenListenerComponent = (props: Props) => {
    const [emailId, setEmailId] = React.useState<any>(null);
    const [eventModelId, setEventModelId] = React.useState<any>(null);

    React.useEffect(() => {
        $(window).on(Nut.View.events.OpenWasClicked, handleOpenWasClicked);

        return () => {
            $(window).off(Nut.View.events.OpenWasClicked, handleOpenWasClicked);
        };
    }, []);

    const handleOpenWasClicked = (
        e: any,
        data: {
            emailId: string;
            eventModelId: string;
        }
    ) => {
        setEmailId(data.emailId);
        setEventModelId(data.eventModelId);
    };

    const handleSave = () => {
        $(window).trigger('ReactTimelineEntryRefresh', {eventModelId: eventModelId});
    };

    const handleDelete = () => {
        $(window).trigger('ReactTimelineEntryRemove', {eventModelId: eventModelId});
    };

    if (emailId) {
        return (
            <>
                <EmailPreviewModal
                    emailId={emailId}
                    onSaveCallback={handleSave}
                    onDeleteCallback={handleDelete}
                    onClose={() => setEmailId(null)}
                    emailReplyTo={(replyType: ReplyType) => {
                        const isReplyingAll = replyType === 'all';
                        props.openReplyModal(emailId, isReplyingAll);
                    }}
                />
            </>
        );
    }

    return null;
};

// @ts-expect-error
const connector = connect<_, Record<any, any>, _, _, _, _>(null, mapDispatchToProps);
export const TimelineEmailOpenListener = connector(TimelineEmailOpenListenerComponent);
